export default "https://a.travel-assets.com/partner-portal/connectivity_logo_white.e7ddf6d15115.svg";